$(document).ready(function(){

  $('.slider-product .owl-carousel').owlCarousel({
    loop:true,
    margin: 20,
    items:1,
    center: true,
    autoplay: true,
    autoplayTimeout:5000,
    responsive:{
        0:{
          items:1,
          center: false,
        },
        576:{
            items:1,
            center: false
        },
        767:{
          items:3
        },
        992:{
            items:4
        },
        1200:{
          items:4
        }
      },
  });

  var transform = 0;
  setInterval(() => {
      transform--;
      if(transform == -2460){
          transform = 0;
      }
      $('.m-slider').attr('style', 'transform: translate3d('+transform+'px, 0px, 0px)');
  }, 20);

  
  $(".m-scroll-content").click(function() {
    $("html, body").animate({ scrollTop: 1000 }, "slow");
    return false;
  });

  var $animation_el = $('.animation-el');
  var $window = $(window);

  function checkIfInView() {
    var windowHeigh = $window.height();
    var windowTopPosition = $window.scrollTop();
    var windowBottomPosition = (windowTopPosition + windowHeigh);

    $.each($animation_el, function() {
      var $el = $(this);
      var elHeight = $el.outerHeight();
      var elTopPosition = $el.offset().top;
      var elBottomPosition = (elTopPosition + elHeight);

      if( (elBottomPosition >= windowTopPosition) && (elTopPosition <= windowBottomPosition)) {
        $el.addClass('path_circle');
      } else {
        $el.removeClass("path_circle");
      }
    });
  }

  $window.on('scroll resize', checkIfInView);
  $window.trigger('scroll');

  // add animation aos img
	AOS.init();

  // back to top
  var backToTop = $('#m-back-top');

  $(window).scroll( function() {
      if ( $(window).scrollTop() > 300 ) {
          backToTop.addClass('show');
      } else {
          backToTop.removeClass('show');
      }
  });

  backToTop.on('click', function(e) {
      e.preventDefault;
      $('html, body').animate({scrollTop:0}, '1000');
  });
});
